import { IAgreementIndex } from 'APIPackage/AgreementListModule/interfaces/IAgreementIndex';

import { IAgreementRaw } from '../interfaces/IAgreementRaw';

export const mapDataItemToRaw = (row: IAgreementIndex) => ({
  ...row,
});

export const mapRawToData = (data: IAgreementIndex[]): IAgreementRaw[] => {
  return data.map(row => {
    return mapDataItemToRaw(row);
  });
};
